import React from "react";
import GrainOverlay from "./GrainOverlay";

/**
 * Shared atmospheric backdrop used on the works gallery and project detail
 * pages. Soft colour flares + heavy stacked film grain, layered over a
 * TRANSPARENT base so the parent page's `backgroundImage` (the editable
 * `worksDeeper.background` slot) shows through. The parent supplies a #000
 * `backgroundColor` fallback for when no image has been uploaded.
 */
export default function FilmBackdrop() {
  return (
    <div
      aria-hidden="true"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 0,
        pointerEvents: "none",
      }}
    >
      {/* Small soft colour flares, no opaque base — see header comment. */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          background:
            "radial-gradient(8% 10% at 14% 22%, rgba(214, 80, 60, 0.55) 0%, rgba(214,80,60,0) 70%)," +
            "radial-gradient(7% 9% at 82% 18%, rgba(80, 140, 220, 0.55) 0%, rgba(80,140,220,0) 70%)," +
            "radial-gradient(9% 11% at 70% 78%, rgba(220, 160, 70, 0.5) 0%, rgba(220,160,70,0) 70%)," +
            "radial-gradient(6% 8% at 30% 70%, rgba(140, 90, 200, 0.5) 0%, rgba(140,90,200,0) 70%)," +
            "radial-gradient(5% 7% at 50% 38%, rgba(90, 200, 180, 0.4) 0%, rgba(90,200,180,0) 70%)," +
            "transparent",
        }}
      />

      {/* Heavy stacked film grain — three layers at different blends/scales */}
      <GrainOverlay opacity={0.6}  blend="overlay"    scale={180} freq={1.4} alpha={0.85} />
      <GrainOverlay opacity={0.35} blend="soft-light" scale={120} freq={1.8} alpha={0.9} />
      <GrainOverlay opacity={0.22} blend="normal"     scale={260} freq={1.0} alpha={0.7} />
    </div>
  );
}
